import React from 'react';
import logo from '../assets/images/logo_1.svg';

function Header() {
  return (
    <header className="headerSection" id="header">
      <div className="container">
        <div className="row align-center">
          <div className="col-md-6 col-4">
            <a href="/">
              <img 
                alt="logo" 
                className="max-width wow animate__animated animate__rubberBand"
                src={logo} 
              />
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;

